ScoreTrekBattle.Tournament.Draw = (function() {
    var _this, STATUS;

    function resetStatus() {
        STATUS = {
            $view: null,
            dragging: false,
            teamSize: 1,
            resolve: () => {},
            reject: () => {},
            teams: {},
            matches: []
        };
    }
    resetStatus();

    function setMatches(round) {
        round.games.forEach(game => {
            STATUS.matches.push({
                team1: STATUS.teams[game.team1],
                team2: STATUS.teams[game.team2 || game.team2Designated],
                team1From: game.team1From,
                team2From: game.team2From,
                fullEdit: round.isEditable
            });
        });
    }

    function renderMatches() {
        return new Promise(resolve => {
            let matchPromises;

            matchPromises = [];
            STATUS.matches.forEach(match => {
                matchPromises.push(renderMatch(match));
            });

            Promise.all(matchPromises).then($matches => {
                resolve($matches);
            });
        });    
    }

    function renderMatch(match) {
        return new Promise(resolve => {
            ScoreTrekBattle.Template.render('tournament/draw/match').then(template => {
                ScoreTrekBattle.Tournament.Group.renderTeams([match.team1, match.team2], STATUS.teamSize).then($teams => {
                    template.$view.find('[data-id="team1"]').append($teams[0]).toggleClass('isFixed', !match.fullEdit).toggleClass('isMovable', match.fullEdit);
                    template.$view.find('[data-id="team2"]').append($teams[1]).toggleClass('isFixed', false).toggleClass('isMovable', true);

                    if (match.fullEdit) {
                        template.$view.find('[data-id="team1"] [data-id="team"]').attr('data-team-from', match.team1From);
                        template.$view.find('[data-id="team2"] [data-id="team"]').attr('data-team-from', match.team2From);
                        template.$view.find('[data-id="team1"] [data-id="teamFrom"]').html(getTeamFrom(match.team1From)).css('display', '');
                        template.$view.find('[data-id="team2"] [data-id="teamFrom"]').html(getTeamFrom(match.team2From)).css('display', '');
                    }

                    resolve(template.$view);
                });
            });
        });
    }

    function getTeamFrom(teamFrom) {
        let teamFromParts;
        teamFromParts = String(teamFrom).split(':');

        return ScoreTrekBattle.Tournament.Match.renderTeamFrom(
            teamFromParts[1],
            ScoreTrekBattle.Tournament.Live.getGame(teamFromParts[0] || ''),
            ScoreTrekBattle.Tournament.Live.getGroup(teamFromParts[0] || ''),
            false
        );
    }

    function showDialog($matches) {
        ScoreTrekBattle.Template.render('tournament/draw/draw').then(template => {
            STATUS.$view = template.$view;

            STATUS.$view.find('[data-id="matches"]').append($matches);

            enableDragDrop();

            chmDialog({
                title: __i18n(`dialog/draw/title`),
                content: STATUS.$view,
                large: true,
                centerButtons: true,
                buttons: [
                    {
                        label: __i18n('button/apply'),
                        primary: true,
                        action: function() {
                            STATUS.resolve(getTeamIds());
                        }
                    },
                    {
                        label: __i18n('button/cancel'),
                        action: function() {
                            STATUS.reject();
                        }
                    }
                ]
            });
        });
    }

    function enableDragDrop() {
        var $scrollable;

        $scrollable = STATUS.$view.find('[data-id="matches"]');

        STATUS.$view.find('.isMovable [data-id="team"]').draggable({
            revert: 'invalid',
            start: function(event, ui) {
                var $this, offsetTop;

                STATUS.dragging = true;

                $this = $(this);
                this.classList.add('isDragged');
                this.classList.remove('wasMoved');
                STATUS.$view.find('[data-id="team"]').css('z-index', '');
                this.style.zIndex = 999999;

                STATUS.$view.find('[data-id="match"]').css('z-index', '');
                $this.closest('[data-id="match"]').css('z-index', 999999);

                offsetTop = ($this.offset().top - $scrollable.offset().top);
                $scrollable.attr({
                    'data-min-top': (1 - offsetTop - $scrollable.scrollTop()),
                    'data-max-top': ($scrollable.get(0).scrollHeight - $scrollable.scrollTop() - offsetTop - this.offsetHeight),
                    'data-scroll-top': $scrollable.scrollTop()
                });
            },
            drag: function(event, ui) {
                var minTop, maxTop, justifiedTop, initialScrollTop;

                minTop = parseInt($scrollable.attr('data-min-top'), 10);
                maxTop = parseInt($scrollable.attr('data-max-top'), 10);

                initialScrollTop = parseInt($scrollable.attr('data-scroll-top'), 10);
                justifiedTop = (ui.position.top - $scrollable.scrollTop() + initialScrollTop);

                ui.position.top = Math.max(minTop, Math.min(maxTop, justifiedTop));
            },
            stop: function(event, ui) {
                this.classList.remove('isDragged');
                this.style.zIndex = '';

                STATUS.dragging = false;
            }
        });

        STATUS.$view.find('.isMovable [data-id="team"]').droppable({
            accept: '[data-id="team"]',
            over: function(event, ui) {
                this.classList.add('allowDrop');
            },
            out: function(event, ui) {
                this.classList.remove('allowDrop');
            },
            drop: function(event, ui) {
                var $draggable, $droppable, $draggableParent, $droppableParent;
                $draggable = ui.draggable;

                this.classList.remove('allowDrop');
                $draggable.attr('style', '');

                $droppable = $(this);

                $draggableParent = $draggable.closest('.isMovable');
                $droppableParent = $droppable.closest('.isMovable');

                $draggableParent.append($droppable);
                $droppableParent.append($draggable);

                $draggable.addClass('wasDropped');
                $draggable.attr('style', '');

                $droppable.addClass('wasMoved');
                $droppable.removeClass('wasDropped');
            }
        });
    }

    function getTeamIds() {
        let teamIds;

        teamIds = [];

        STATUS.$view.find('[data-id="match"]').each(function() {
            let $teams;
            $teams = $(this).find('[data-id="team"]');
            teamIds.push({
                team1: $teams.get(0).dataset.teamId,
                team2: $teams.get(1).dataset.teamId,
                team1From: $teams.get(0).dataset.teamFrom,
                team2From: $teams.get(1).dataset.teamFrom
            });
        });

        return teamIds;
    }

    _this = {
        edit: function(tournament, round, teams) {

            return new Promise((resolve, reject) => {
                resetStatus();

                STATUS.resolve = (teams) => {
                    resolve(teams);
                    resetStatus();
                };

                STATUS.reject = () => {
                    reject();
                    resetStatus();
                };

                STATUS.teamSize = tournament.preset.teamSize || 1;
                STATUS.teams = teams;

                setMatches(round);

                renderMatches().then($matches => {
                    showDialog($matches);
                });
            });
        }
    };

    return _this;
})();